import {
  camelCase,
  isArray,
  isBoolean,
  isEmpty,
  isNull,
  isObject,
  merge,
  omitBy,
  reduce,
  snakeCase,
} from "lodash";
import { CamelCasedPropertiesDeep } from "type-fest/source/camel-cased-properties-deep";

export const omitEmpty = (obj: Record<string, any>) => {
  return omitBy(obj, (value) => {
    if (isBoolean(value)) {
      return false;
    }
    return isEmpty(value);
  });
};

export const mergeObjects = (...objs: any[]) => {
  const validObjs = objs.filter(Boolean);
  return validObjs.reduce((acc, obj) => {
    return merge({}, acc, obj);
  }, {});
};

export const camelToSnakeCase = (
  obj?: Record<string, any>,
): Record<string, any> | undefined => {
  if (!isObject(obj) || isNull(obj)) {
    return obj;
  }

  if (isArray(obj)) {
    return obj.map(camelToSnakeCase);
  }

  return reduce(
    obj,
    (result: Record<string, any>, value, key: string) => {
      const snakeKey: string = snakeCase(key);

      result[snakeKey] = camelToSnakeCase(value);

      return result;
    },
    {},
  );
};

export const snakeToCamelCase = <T extends Record<string, any>>(
  obj?: T,
): CamelCasedPropertiesDeep<T> | undefined => {
  if (!isObject(obj) || isNull(obj)) {
    return obj;
  }

  if (isArray(obj)) {
    return obj.map(snakeToCamelCase) as CamelCasedPropertiesDeep<T>;
  }

  return reduce(
    obj,
    (result: Record<string, any>, value, key: string) => {
      const camelKey = camelCase(key);

      result[camelKey] = snakeToCamelCase(value);

      return result;
    },
    {} as CamelCasedPropertiesDeep<T>,
  ) as CamelCasedPropertiesDeep<T>;
};
